<template>
  <div class="flex lg:flex-row flex-col justify-center lg:gap-0 gap-3 h-full">
    <!-- Tabs buttons -->
    <div
      class="lg:flex lg:flex-col grid grid-cols-1 gap-4 h-fit mt-14 mx-4 relative z-50 lg:w-1/5"
      :dir="props.pageLang == 'ar' ? 'ltr' : 'rtl'"
    >
      <p
        class="text-end border-b border-secondary-200 font-bold text-lg lg:block hidden"
      >
        {{ translate(props.tabs[props.activeTabIndex].label, props.pageLang) }}
      </p>
      <button
        v-for="tab in props.tabs"
        :key="tab"
        :class="[
          'relative z-1 lg:py-4 py-4 lg:px-2 px-1 text-xs transition-all duration-600 ease-in-out text-end bg-white rounded-lg border border-secondary-300 font-semibold',
          props.tabs[props.activeTabIndex].key === tab.key
            ? `${props.pageLang == 'ar' ? 'border-r-8' : 'border-l-8'} border-secondary-700`
            : `${props.pageLang == 'ar' ? 'hover:border-r-8' : 'hover:border-l-8'} hover:border-secondary-700 text-gray-700 hover:text-black `,
        ]"
        @click="updateActiveTabIndex(tab)"
      >
        {{ translate(tab.label, props.pageLang) }}
        <span
          v-if="tab.beta"
          class="text-md text-primary-600 p-2 rounded-xl capitalize mx-4 font-bold animate-pulse"
          >{{ translate('general.beta', props.pageLang) }}</span
        >
      </button>
    </div>

    <div class="w-full h-full">
      <!-- Tab content -->
      <div class="w-full h-full px-4">
        <slot
          class="overflow-auto"
          :name="props.tabs[props.activeTabIndex].key"
          :pageLang="props.pageLang"
          :pageDir="props.pageDir"
        ></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Imports Vue Packages
import { translate } from 'src/utils/translation'

// Props and Emits
const props = defineProps<{
  tabs: any
  activeTabIndex: any
  activeTabKey?: string
  pageLang?: string
  pageDir?: string
}>()

const emits = defineEmits<{
  (e: 'update:activeTabIndex', value: string): void
}>()

const updateActiveTabIndex = (selectedTab: any) => {
  const index = props.tabs.findIndex((tab: any) => tab.key == selectedTab.key)
  if (index != -1) {
    if (props.activeTabKey) localStorage.setItem(props.activeTabKey, index.toString())
    emits('update:activeTabIndex', index)
  }
}
</script>
